export enum Dispositivos {
    XSMALL = 'device-xsmall',
    SMALL = 'device-small',
    MEDIUM = 'device-medium',
    LARGE = 'device-large',
    XLARGE = 'device-xlarge',
}